import { useState } from 'react';

/**
 * Custom hook for managing email registration modal state
 * 
 * @returns {Object} Object containing modal state and handler functions
 */
export const useEmailRegistration = () => {
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  
  const openRegistrationModal = () => {
    setShowRegistrationModal(true);
  };
  
  const closeRegistrationModal = () => {
    setShowRegistrationModal(false);
  };
  
  return {
    showRegistrationModal,
    openRegistrationModal,
    closeRegistrationModal
  };
};

export default useEmailRegistration;
